<template>
  <el-dialog title="支付流水详情" :visible="true" width="720px" :before-close="handleClose"  :close-on-click-modal="false">
    <div class="detail">
      <el-form :inline="true" label-width="100px">
        <div class='link-top'></div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="交易类型">
              {{ row.flowType | keyFilter('myAccount', 'flowType')}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业务单号">
              {{ row.bizId }}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="line">
          <el-col :span="12">
            <el-form-item label="金额">
              {{ row.money }}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              {{ row.flowStatus | keyFilter('myAccount', 'flowStatus') }}
            </el-form-item>
            <div class='link-center'></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="市场">
              {{ row.marketName }}
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="getType() === 'cash'">
            <el-form-item label="付款账号">
              {{ row.payAccount }}
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="getType() === 'cash'">
            <el-form-item label="付款账户名">
              {{ row.payAccountName }}
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="getType() === 'charge'">
            <el-form-item label="收款账号">
              {{ row.recvAccount }}
            </el-form-item>
          </el-col>
          <el-col :span="24" v-if="getType() === 'charge'">
            <el-form-item label="收款账户名">
              {{ row.recvAccountName }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="申请时间">
              {{ row.createDate }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="支付时间">
                {{ row.payTime }}
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注">
              {{ row.remark }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'detail',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  methods: {
    handleClose () {
      this.$emit('close')
    },
    // 判断充值还是提现
    getType () {
      if (this.row.flowType === 'DPT_PT_IN' || this.row.flowType === 'DPT_XS_IN') {
        return 'charge'
      } else if (this.row.flowType === 'DPT_OUT' || this.row.flowType === 'DPT_XS_OUT') {
        return 'cash'
      } else {
        return ''
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  ::v-deep .el-dialog__title {
    font-size: 16px;
    color: rgba(51,51,51,0.94);
    font-family: '微软雅黑'
  }
  ::v-deep .el-dialog__header {
    padding-bottom: 0px;
  }
  ::v-deep .el-form-item {
    margin-bottom: 0;
  }
  .line {
    border-bottom: solid #ccc 1px;
  }
  .link-top {
    width: 100%;
    height: 1px;
    border-top: solid #f8bd47 1px;
    margin-bottom: 15px;
  }
  .link-center {
    width: 100%;
    height: 1px;
    margin-top: 15px;
  }
</style>
